import React from 'react'

const TrackingItemPlaceholder = props => (
  <div className='row py-1 px-0'>
    <div className='order-tracking col-12 px-0 pb-1'>
      <div className='row mx-0 align-items-center h-100'>
        <div className='col-12 pb-3 px-0'>
          <h3 className='color-ui-2 txt-uppercase txt-body txt-circular-black'>
            DETALHE DO RASTREAMENTO
          </h3>
        </div>
        <ul className='tracking-steps col-12 px-0'>
          <li className='pos-relative'>
            <div className='row'>
              <div className='col-auto'>
                <div className='row mx-0'>
                  <div className='col-auto py-2 px-2 bg-ui-3 radius-circle' />
                </div>
              </div>
              <div className='col'>
                <div className='row mx-0 shimmer'>
                  <div className='col-6 py-half bg-ui-3 radius' />
                  <div className='col-9 mt-1 py-half bg-ui-4 radius' />
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
)

export default TrackingItemPlaceholder



// WEBPACK FOOTER //
// ./src/Participant/MyOrders/ProductOrderDetail/ProductSide/TrackingItemPlaceholder.js